import { memo } from 'react';

const Hero = () => {
  return (
    <section id="about" className="term-section term-hero">
      <div className="term-container">
        <div className="term-hero-prompt">
          <span className="term-hero-prompt-cmd">whoami</span>
          <span className="term-cursor" aria-hidden="true"></span>
        </div>

        <h1 className="term-hero-name">Vijoy Paul</h1>
        <p className="term-hero-role">Full-Stack Developer &mdash; Node.js &middot; React &middot; MongoDB &middot; Docker &middot; GCP</p>

        <p className="term-hero-bio">
          Full-stack developer passionate about building scalable web applications,
          RESTful APIs, and microservices using modern technologies. Proficient in
          CI/CD pipelines, containerization, and cloud deployment.
        </p>

        <div className="term-hero-meta" role="list">
          <span className="term-hero-meta-key" role="listitem">role</span>
          <span className="term-hero-meta-val">Full-Stack Developer</span>
          <span className="term-hero-meta-key" role="listitem">location</span>
          <span className="term-hero-meta-val">India</span>
          <span className="term-hero-meta-key" role="listitem">status</span>
          <span className="term-hero-meta-val">available for opportunities</span>
          <span className="term-hero-meta-key" role="listitem">github</span>
          <span className="term-hero-meta-val">
            <a href="https://github.com/vijoy-paul" target="_blank" rel="noopener noreferrer">github.com/vijoy-paul</a>
          </span>
          <span className="term-hero-meta-key" role="listitem">linkedin</span>
          <span className="term-hero-meta-val">
            <a href="https://linkedin.com/in/vijoy-paul" target="_blank" rel="noopener noreferrer">linkedin.com/in/vijoy-paul</a>
          </span>
        </div>

        <div className="term-hero-actions">
          <a href="#projects" className="term-btn term-btn-primary">view projects</a>
          <a href="#contact" className="term-btn">get in touch</a>
        </div>
      </div>
    </section>
  );
};

export default memo(Hero);
